import { makeRequest } from 'services/request.service'

export const listTariffRates = (params = {}) => makeRequest({ method: 'GET', url: '/tariff-rates', params })
export const deleteTariffRate = (fraction) => makeRequest({ method: 'DELETE', url: `/tariff-rates/${fraction}` })
export const importTariffRates = (file) => {
  const form = new FormData()
  form.append('file', file)
  return makeRequest({ method: 'POST', url: '/tariff-rates/import', data: form, headers: { 'Content-Type': 'multipart/form-data' } })
}
